import { bounceIn, fadeIn, flipInX, flipInY, jello, pulse, shake, swing, tada, zoomIn } from 'react-animations';
import styled, { keyframes } from 'styled-components';

const pulseAnimation = keyframes`${pulse}`;
const shakeAnimation = keyframes`${shake}`;
const tadaAnimation = keyframes`${tada}`;
const bounceInAnimation = keyframes`${bounceIn}`;
const fadeInAnimation = keyframes`${fadeIn}`;
const flipInXAnimation = keyframes`${flipInX}`;
const flipInYAnimation = keyframes`${flipInY}`;
const zoomInAnimation = keyframes`${zoomIn}`;
const swingAnimation = keyframes`${swing}`;
const jelloAnimation = keyframes`${jello}`;

export const Pulse = styled.div`
  animation: 2s ${pulseAnimation};
  animation-delay: 2s;
`;

export const Shake = styled.div`
  animation: 2s ${shakeAnimation};
  animation-delay: 2s;
`;

export const Tada = styled.div`
  animation: 2s ${tadaAnimation};
  animation-delay: 2s;
`;

export const BounceIn = styled.div`
  animation: 2s ${bounceInAnimation};
  animation-delay: 2s;
`;

export const FadeIn = styled.div`
  animation: 2s ${fadeInAnimation};
  animation-delay: 2s;
`;

export const FlipInX = styled.div`
  animation: 2s ${flipInXAnimation};
  animation-delay: 2s;
`;

export const FlipInY = styled.div`
  animation: 2s ${flipInYAnimation};
  animation-delay: 2s;
`;

export const ZoomIn = styled.div`
  animation: 2s ${zoomInAnimation};
  animation-delay: 2s;
`;

export const Swing = styled.div`
  animation: 2s ${swingAnimation};
  animation-delay: 2s;
`;

export const Jello = styled.div`
  animation: 2s ${jelloAnimation};
  animation-delay: 2s;
`;
